import { backendApi, Result } from "./backendApi";

export interface BodyStyleInfoModel {
  id?: number;
  info?: string;
  english?: string;
  dutch?: string;
  german?: string;
  french?: string;
  spanish?: string;
  portugues?: string;
  italian?: string;
  polish?: string;
  czech?: string;
  swedish?: string;
  danish?: string;
  norwegian?: string;
  finnish?: string;
  hungarian?: string;
  croatian?: string;
  hebrew?: string;
  slovene?: string;
  russian?: string;
  arabic?: string;
  ukrainian?: string;
}

class GetBodyStyleInfosRequest {}

class GetBodyStyleInfosResponse {
  bodyStyleInfos?: BodyStyleInfoModel[];
}

export const bodyStyleInfoApi = {
  async getBodyStyleInfos(): Promise<Result<BodyStyleInfoModel[]>> {
    let response =
      await backendApi.sendAndGetResponseAsync<GetBodyStyleInfosResponse>(
        "GetBodyStyleInfos",
        new GetBodyStyleInfosRequest(),
      );

    if (response.ok) {
      return { ok: true, value: response.value.bodyStyleInfos ?? [] };
    }

    return response;
  },
};
